import { render, staticRenderFns } from "./BT-Notes.vue?vue&type=template&id=bc020d42&scoped=true&"
import script from "./BT-Notes.vue?vue&type=script&lang=js&"
export * from "./BT-Notes.vue?vue&type=script&lang=js&"
import style0 from "./BT-Notes.vue?vue&type=style&index=0&id=bc020d42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc020d42",
  null
  
)

export default component.exports